module.exports = __webpack_public_path__ + "static/media/no_ads_jan_2022_thumb.59a52fd2.jpg";